import { Typography } from "@mui/material";
import { ReactComponent as RightArrow } from "assets/arrow-right-white.svg";
import { ReactComponent as EVHomeIcon } from "assets/icon-ev-home.svg";
import { ReactComponent as EVMoneyIcon } from "assets/icon-ev-money.svg";
import { ReactComponent as EVVehicleIcon } from "assets/icon-ev-vehicle.svg";
import { media } from "lib/styles";
import React from "react";
import { Link } from "react-router-dom";
import { styled } from "styled-components";
import Button from "ui/components/Button";
import { Card, RowLayout } from "ui/components/StyledComponents";
import { PADDING } from "ui/theme";

const MRowLayout = styled(RowLayout)`
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  ${media.md`
    flex-direction: row;
  `}
`;

const SCard = styled(Card)`
  display: flex;
  flex-basis: calc(50% - ${PADDING.medium});
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: ${PADDING.large};
  margin-right: 0;
  min-width: 5rem;

  & a {
    border-radius: 50%;
    min-width: 3rem;
    padding: 0;
    width: 3rem;
  }
`;
const PaddedContainer = styled.div`
  flex: 1;
  margin-right: ${PADDING.xLarge};
`;

const SRowLayout = styled(RowLayout)`
  flex-basis: 60%;
  padding-top: ${PADDING.large};
  flex-direction: column;
  ${media.md`
    flex-direction: row;
  `}
`;

export const EvPlanWithoutChargerCompletion: React.FC = () => {
  return (
    <MRowLayout>
      <PaddedContainer>
        <Typography variant="h2">
          Super charge your benefits with a smart charger
        </Typography>
        <Typography variant="body1">
          Our EV plan is designed to help you up your home charging game - to
          ensure you can reap the benefits from your shift to electric. Add an
          Evnex smart charger to further fast-track your savings.
        </Typography>
      </PaddedContainer>
      <SRowLayout>
        <SCard>
          <EVHomeIcon />
          <Typography variant="h3">Safer for your home</Typography>
          <Typography variant="body1">
            Evnex smart chargers manage your home's power load, reducing the
            risk of fire or damage to your home when charging.
          </Typography>
          <Button
            variant="contained"
            component={Link}
            to={`${process.env.REACT_APP_Z_WEBSITE_URL}products-and-services/power-your-home/ev-at-home-plan/`}
            target="_blank"
            id="button-link-home-safety"
          >
            <RightArrow />
          </Button>
        </SCard>
        <SCard>
          <EVVehicleIcon />
          <Typography variant="h3">Better for your vehicle</Typography>
          <Typography variant="body1">
            Maximise your battery's lifespan by charging right before your
            morning commute.
          </Typography>
          <Button
            variant="contained"
            component={Link}
            to={`${process.env.REACT_APP_Z_WEBSITE_URL}products-and-services/power-your-home/ev-at-home-plan/`}
            target="_blank"
            id="button-link-home-safety"
          >
            <RightArrow />
          </Button>
        </SCard>
        <SCard>
          <EVMoneyIcon />
          <Typography variant="h3">Interest free repayments</Typography>
          <Typography variant="body1">
            Pay off your Evnex smart charger as part of your monthly power bill
            over 24 months, with no interest!
          </Typography>
          <Button
            variant="contained"
            component={Link}
            to={`${process.env.REACT_APP_Z_WEBSITE_URL}products-and-services/power-your-home/ev-at-home-plan/`}
            target="_blank"
            id="button-link-home-safety"
          >
            <RightArrow />
          </Button>
        </SCard>
      </SRowLayout>
    </MRowLayout>
  );
};
